
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[creatorSlug]/user-profile",
      function () {
        return require("private-next-pages/[creatorSlug]/user-profile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[creatorSlug]/user-profile"])
      });
    }
  